import { useMemo } from "react";

import {
  OrganizationRoles,
  Roles,
  SharingRights,
} from "@/shared/utils/constants";
import { getEvidenceContributors } from "@/domains/evidence/hooks/useEvidenceFields";
import { useDisabledEvidenceTemplates } from "@/domains/evidence/hooks/useEvidenceTemplates";
import { DataBlockPermissionsOptions } from "@/domains/datablocks/types";

export const useDataBlockPermissions = (
  options: DataBlockPermissionsOptions = {},
) => {
  const { dataBlock, dataTemplate, currentUser } = options;
  const disabledTemplates = useDisabledEvidenceTemplates();

  const disabledTemplateTitles = useMemo(() => {
    return (disabledTemplates || []).reduce<string[]>((acc, template) => {
      acc.push(template.title);
      return acc;
    }, []);
  }, [disabledTemplates]);

  return useMemo(() => {
    const canCreate =
      currentUser?.organizationRole &&
      [
        OrganizationRoles.ADMIN.value,
        OrganizationRoles.SUPERVISOR.value,
        OrganizationRoles.CONTRIBUTOR.value,
      ].includes(currentUser.organizationRole);

    const isAppAdmin = currentUser?.role === Roles.ADMIN.value;
    const isMemberOfOrganization =
      currentUser?.organization?.id === dataBlock?.organization.id;
    const canView =
      isAppAdmin ||
      isMemberOfOrganization ||
      dataBlock?.sharingRights != SharingRights.PRIVATE.value;

    return {
      canCreate,
      canView,
      canDelete: dataBlock?.canDelete || false,
      canEdit: dataBlock?.canEdit || false,
      isOwner: currentUser?.id === dataBlock?.createdBy?.id,
      isContributor:
        dataBlock && currentUser
          ? getEvidenceContributors(dataBlock).includes(currentUser.id)
          : false,
    };
  }, [dataBlock, dataTemplate, disabledTemplateTitles, currentUser]);
};
